const Layout = () => import('@/layout/index.vue');
import queryDataSvg from '@/assets/svg/queryData.svg';
import dataDetailSvg from '@/assets/svg/dataDetail.svg';

export default {
  path: '/data',
  name: 'Data',
  component: Layout,
  meta: {
    icon: queryDataSvg,
    iconType: 'svg',
    title: '数据查询',
    rank: 2,
    permission: ['root', 'admin', 'user']
  },
  children: [
    // {
    //   path: '/data/database',
    //   name: 'Database',
    //   component: () => import('@/views/data/database/index.vue'),
    //   meta: {
    //     title: '数据概览',
    //     icon: 'histogram'
    //   }
    // },
    {
      path: '/data/detail',
      name: 'Detail',
      component: () => import('@/views/data/detail/index.vue'),
      meta: {
        title: '订购详情',
        icon: dataDetailSvg,
        iconType: 'svg'
      }
    },
    {
      path: '/data/msgDetail',
      name: 'msgDetail',
      component: () => import('@/views/data/msgDetail/index.vue'),
      meta: {
        title: '短信详情',
        icon: 'message'
      }
    },
    {
      path: '/data/rightDetail',
      name: 'rightDetail',
      component: () => import('@/views/data/rightDetail/index.vue'),
      meta: {
        title: '权益详情',
        icon: dataDetailSvg,
        iconType: 'svg'
      }
    },
    {
      path: '/data/target',
      name: 'target',
      component: () => import('@/views/data/target/index.vue'),
      meta: {
        title: '目标日量',
        icon: 'document'
      }
    }
    // {
    //   path: '/data/channel',
    //   name: 'Channel',
    //   component: () => import('@/views/data/channel/index.vue'),
    //   meta: {
    //     title: '渠道数据',
    //     icon: 'list'
    //   }
    // },
    // {
    //   path: '/data/inventory',
    //   name: 'Inventory',
    //   component: () => import('@/views/data/inventory/index.vue'),
    //   meta: {
    //     title: '库存数据',
    //     icon: 'ticket'
    //   }
    // }
  ]
};
